import { createReduxEnhancer } from '@sentry/react';
import { ACTIVATE_FILTER, ACTIVATE_FILTERS, DEACTIVATE_FILTER } from '@Actions/search';
import { HAS_REDUX_DEVTOOLS } from './devtoolsReduxEnhancer';
// These action types are safe for us to send the full payload (other actions only send the type)
const NON_PRUNED_ACTIONS = [ACTIVATE_FILTER, ACTIVATE_FILTERS, DEACTIVATE_FILTER];
export const sentryReduxEnhancer = createReduxEnhancer({
    actionTransformer: (action) => {
        // If dev tools are active, then the real action may be wrapped
        const actualAction = HAS_REDUX_DEVTOOLS && action.type === 'PERFORM_ACTION' ? action.action : action;
        if (NON_PRUNED_ACTIONS.includes(actualAction.type)) {
            return actualAction;
        }
        return {
            type: actualAction.type
        };
    },
    stateTransformer: () => null // Don't send the application state to Sentry
});
